import { makeRequestAction } from './index';

export const getPropertyClasses = makeRequestAction('GET_PROPERTY_CLASSES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
